//import gcashQRHavoc1 from '../assets/images/gcashQRhavoc1.png'
import gcashQRHavoc2 from '../assets/images/gcashQRhavoc2.png'
//import gcashQRHavoc3 from '../assets/images/gcashQRhavoc3.png'

import gcashQRStrife from '../assets/images/gcashQRstrife.png'

export const PAYMENT_RECIPIENTS = {

     STRIFE: {
    gcash: {
      title: 'GCASH',
      recipients: [
        {
          name: 'JH****L M.',
          number: '0910-156-2264',
          accountLimit: false
        },
        {
          name: 'HE*****A L.',
          number: '0976-220-4009',
          accountLimit: true
        },
        {
          name: 'NI***E L.',
          number: '0976-128-1087',
          accountLimit: true
        }
      ],
      qrImage: gcashQRStrife 
    },
     maya: {
      title: 'MAYA',
       name: 'JHENELL M.',
        number: '0910-156-2264'
    },

    paypal: {
      title: 'PAYPAL',
      email: 'menesesjhenell@gmail.com'
    }
  },

////////////////////////////////////////HAVOC
////////////////////////////////////////HAVOC
  HAVOC: {
    gcash: {
      title: 'GCASH',
      recipients: [
        {
          name: 'CA*******A G.',
          number: '0960-816-0501',
          accountLimit: false
        },
        {
          name: 'JU****A P.',
          number: '0993-318-7050',
          accountLimit: false
        },
        {
          name: 'AP*******O G.',
          number: '0960-876-4257',
          accountLimit: true
        }
      ],
      qrImage: gcashQRHavoc2
    },
      maya: {
      title: 'MAYA (UNAVAILABLE)',
       name: '(UNAVAILABLE)',
        number: '(UNAVAILABLE)'
    },

    paypal: {
      title: 'PAYPAL',
      email: 'menesesjhenell@gmail.com'
    }
  },

  rules: {
    rate: '1 PHP = 1 E-POINT',
    minAmount: 100,
    disclaimer:
      'TOPUP ARE PURELY VOLUNTARY, NON-COMPULSORY, NON-TRANSFERABLE AND NON-REFUNDABLE.'
  }
}
